/* Un importe, escrito como se escribe la plata en Argentina.
 *
 * VIVE SOLO Y NO ADENTRO DE UNA PANTALLA porque lo usan dos: los comprobantes
 * que llegan por WhatsApp y las facturas que llegan por mail. Son dos listas de
 * los mismos papeles leídos por el mismo modelo, y el día que las dos escriban
 * el mismo total distinto, la que está mal es indistinguible de la que está
 * bien.
 *
 * `null` es «no hay importe», y la pantalla lo dibuja como el hueco que es. Un
 * «$ 0,00» inventado se lee como una factura de cero pesos.
 */
export function plata(importe, moneda) {
  if (importe === null || importe === undefined || importe === "") return null;
  const n = Number(importe);
  if (!Number.isFinite(n)) return null;
  return `${moneda || "ARS"} ${n.toLocaleString("es-AR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}
